import InventoryListingInfo from './InventoryListingInfo';
export default InventoryListingInfo;